import { render, staticRenderFns } from "./ActivityUpdateModalComp.vue?vue&type=template&id=bb829aae&scoped=true"
import script from "./ActivityUpdateModalComp.vue?vue&type=script&lang=js"
export * from "./ActivityUpdateModalComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb829aae",
  null
  
)

export default component.exports